import React, { useState } from "react";
import styled from "styled-components";
// import bgImageVertical from "../assets/horizontal_full_angle_payment_page.jpg";
import iscreenPaymentbgImage from "../assets/iscreen_payment_page_bg.jpg";
import urduflixPaymentbgImage from "../assets/urduflix_payment_page_bg.png";
import defaultPaymentbgImage from "../assets/default_payment_page_bg.png";
import checkbox from "../assets/checkbox_small.svg";
import checkboxChecked from "../assets/checkbox_checked_red.svg";
import { Box } from "../components/styled/box";
import { FaCheck } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingDots from "../components/InlineLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  getResponseByCountry,
  getResponseByPackageType,
  getLocation,
  getResponseByCoupon,
} from "../redux/payment/payment.slice";
import {
  Container,
  Wrapper,
  PackagesContainer,
  SinglePackage,
  Header,
  ListContainer,
  List,
  ActivePayment,
  BgContainer,
} from "./styles/Payment.style";
import {
  postSsl,
  postCouponSubscription,
} from "../redux/subscription/subscription.utils";
import { LoaderCircle } from "../components/styled/loaders";
import Modal from "../components/Modal";
import { getCookie, getDomainName, getUserType } from "../utils/helpers";
import jwtDecode from "jwt-decode";

const PaymentPage = () => {
  const dispatch = useDispatch();
  const {
    items,
    location,
    couponStatus,
    couponLoading,
    couponMessage,
    loading,
  } = useSelector((state) => state.payment);
  // const { theme } = useSelector((state) => state.theme);
  const theme = "dark";
  // const [country, setCountry] = useState("");
  const [selectedPackage, setSelectedPackage] = useState({});
  const [activeMethods, setActiveMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [postLoading, setPostLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [autoRenwal, setAutoRenewal] = useState(true);
  const [promoCode, setPromoCode] = useState("");
  const iconLogo = window?.platform_info?.logo;
  const navigate = useNavigate();
  const { search } = useLocation();
  // fb promotion link with a specific package (e.g. &package=monthly).
  // captured once on mount, since the country navigate below replaces the query string
  const [packageType] = useState(() => {
    const params = new URLSearchParams(search);
    return params.get("ref") === "fbclick" ? params.get("package") : null;
  });

  const platform = localStorage.getItem("platform");
  const hashValue = getCookie("hash");
  const decodedToken = hashValue && jwtDecode(hashValue);
  const isCoupon = selectedMethod?.type === "coupon";
  // when coupon is selected, CONTINUE stays disabled until a code is validated
  const isContinueDisabled = isCoupon && couponStatus !== "true";

  React.useEffect(() => {
    const brandName = getDomainName(platform);
    if (brandName === "urduflix") {
      setAutoRenewal(false);
    }
  }, [platform]);

  React.useEffect(() => {
    dispatch(getLocation());
  }, [dispatch]);

  // React.useEffect(() => {
  //   setCountry(location.countryCode);
  // }, [location.countryCode]);

  React.useEffect(() => {
    if (location.countryCode) {
      if (location.countryCode !== "BD") {
        setAutoRenewal(false);
      }
      if (packageType) {
        dispatch(
          getResponseByPackageType({
            country_code: location.countryCode,
            packageType,
          }),
        );
      } else {
        dispatch(getResponseByCountry(location.countryCode));
      }
      navigate(`?country=${location.countryCode}`);
    }
  }, [dispatch, location.countryCode, navigate, packageType]);

  React.useEffect(() => {
    setSelectedPackage(items?.items?.[0]);
  }, [items?.items]);

  React.useEffect(() => {
    let allMethods = Object.values(selectedPackage?.paymentMethods ?? {});

    const activeMethods = allMethods.flatMap((method) =>
      Array.isArray(method) ? method : [],
    );

    if (autoRenwal) {
      const renewalMethods = activeMethods.filter(
        (item) => item.is_auto_renewal === autoRenwal,
      );
      setActiveMethods(renewalMethods);
      setSelectedMethod(renewalMethods[0]);
    } else {
      setActiveMethods(activeMethods);
      setSelectedMethod(activeMethods[0]);
    }
  }, [selectedPackage?.paymentMethods, autoRenwal]);

  // React.useEffect(() => {}, [autoRenwal, activeMethods]);

  const handleSubmit = async () => {
    //console.log('>>>>>>', currentUser, packageInfo);
    // console.log("selected Method", selectedMethod);
    if (
      !selectedMethod ||
      selectedMethod === "undefined" ||
      selectedMethod === "null"
    ) {
      setOpenModal(true);
      setModalContent("You have not selected a payment method!");
    } else {
      setPostLoading(true);
      // from promotional link
      if (decodedToken?.role === 4) {
        window.location.href = `https://${platform}?ref=paymentlanding&package=${selectedMethod?.type}&product=${selectedMethod?.productId}`;
      } else if (isCoupon) {
        // coupon flow
        try {
          const response = await postCouponSubscription(
            promoCode,
            selectedMethod?.productId,
          );
          setPostLoading(false);
          // open to the api response's message field (redirect url)
          response?.data?.message &&
            window.location.replace(response.data.message);
        } catch (error) {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            error?.response?.data?.message ||
              "Something went wrong. Please try again.",
          );
        }
      } else {
        const userIdentity = decodedToken?.username;
        const paymentMethod = selectedMethod?.type;
        const userType = getUserType(userIdentity);

        // robi and cirkle block if not dsdb
        if (
          !["cirkle", "robi"].includes(userType) &&
          paymentMethod === "robi_dsdb"
        ) {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            "Robi Payment is available only for Robi or Cirkle User!",
          );
          return;
        }
        // gp block if not gpdcb
        if (!["gp"].includes(userType) && paymentMethod === "gpdcb") {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            "Grameenphone Payment is available only for Gp User!",
          );
          return;
        }
        // normal flow
        const response = await postSsl(
          selectedMethod?.type,
          selectedMethod?.productId,
        );
        setPostLoading(false);
        if (response.status === 400) {
          // console.log("Handle Message for 400");
          setOpenModal(true);
          setModalContent(response?.data?.message);
        } else {
          response.data && window.location.replace(response.data?.message);
        }
      }
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    setModalContent("");
  };

  const handlePromo = () => {
    if (promoCode && promoCode.length > 4) {
      dispatch(
        getResponseByCoupon({
          couponCode: promoCode,
          productId: selectedMethod?.productId,
        }),
      );
    } else {
      console.error("No Promo code Applied");
    }
  };

  const getBackgroundImage = () => {
    const platform = localStorage.getItem("platform");
    const brandName = getDomainName(platform);
    // console.log("Platform from localstorage", brandName);
    if (brandName === "urduflix") {
      return urduflixPaymentbgImage;
    }
    if (brandName === "iscreen" || "funprime" || "bingepluslive") {
      return iscreenPaymentbgImage;
    }

    return defaultPaymentbgImage;
  };

  if (loading) {
    return <LoadingDots />;
  }

  // if (postLoading) {
  //   return <LoaderCircle />;
  // }

  return (
    <Container>
      <div>
        <Modal isOpen={openModal} onClose={closeModal}>
          <p>{modalContent}</p>
        </Modal>
      </div>
      <BgContainer $bgImage={getBackgroundImage()}></BgContainer>
      <Wrapper theme={theme}>
        <Header>
          <Box>
            <img
              src={iconLogo}
              style={{ height: "58px", marginBottom: "10px" }}
              alt=""
            />
          </Box>
          <Title style={{ marginBottom: "5px" }}>
            {`Select a plan and start enjoying ${getDomainName(platform)}!`}
          </Title>
          {/* <SmallTitle>Enjoy Premium Now</SmallTitle> */}
          <Subtitle>
            <ul>
              <li>Premium Content</li>
              <li>Stream in High Definition</li>
            </ul>
            <ul>
              <li>Ad Free Experience</li>
              <li>In-app Download</li>
            </ul>
          </Subtitle>
        </Header>

        {postLoading ? (
          <LoaderCircle style={{ width: "55px", height: "55px" }} />
        ) : (
          <PackagesContainer>
            {items.items &&
              items.items.map((item, index) => {
                return (
                  <SinglePackage
                    onClick={() => setSelectedPackage(item)}
                    active={item.id === selectedPackage?.id}
                    key={index}
                    className="only-packages"
                  >
                    <div className="left">
                      <Box>
                        <div className="title">{item.name}</div>
                        <ListContainer>
                          <List>
                            <FaCheck /> <span>{item.name} Subscription</span>
                          </List>
                          <List>
                            <FaCheck />{" "}
                            <span>
                              {" "}
                              Enjoy on all your devices (up to 4 devices)
                            </span>
                          </List>
                          {location?.countryCode === "BD" ? (
                            <List>
                              <FaCheck /> <span>Only Bangladesh</span>
                            </List>
                          ) : (
                            ""
                          )}
                        </ListContainer>
                      </Box>
                    </div>
                    <div className="right">
                      <img
                        src={
                          item.id === selectedPackage?.id
                            ? checkboxChecked
                            : checkbox
                        }
                        alt=""
                      />
                      <div className="price">
                        <p className="currency">
                          {item.originalPrice ? (
                            <span className="original-price">
                              <s>
                                <span>{item.originalPrice}</span>{" "}
                                <span>{item.unit}</span>
                              </s>
                            </span>
                          ) : (
                            ""
                          )}

                          <span className="sale-price">
                            <span>{item.price}</span> <span>{item.unit}</span>
                          </span>
                        </p>
                      </div>

                      {/* <Button
                      variant="primary"
                      className="buy-btn"
                      onClick={() => handleBuyNowClick(item.id)}
                    >
                      Buy Now
                    </Button> */}
                    </div>
                  </SinglePackage>
                );
              })}
            <SinglePackage className="only-methods">
              <div className="heading">
                <div className="title">Pay By</div>
                <div className="auto-renewal">
                  <span>Auto Renewal</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={autoRenwal}
                      onChange={() => setAutoRenewal((prev) => !prev)}
                    />
                    <span className="slider" />
                  </label>
                </div>
              </div>
              <div className="divider"></div>
              <div className="all-methods">
                {activeMethods?.length > 0 ? (
                  activeMethods?.map((innerItem, index) => {
                    return (
                      <ActivePayment
                        key={index}
                        $isCoupon={
                          innerItem?.type === "coupon" &&
                          selectedMethod?.type === "coupon"
                        }
                        // onClick={() => handleSubmit(innerItem)}
                      >
                        <div className="radio-input-div">
                          <input
                            type="radio"
                            name="paymentMethodGroup" // Same name for all in the group
                            id={innerItem?.type}
                            value={innerItem?.type}
                            checked={selectedMethod?.type === innerItem?.type}
                            onChange={(e) => setSelectedMethod(innerItem)}
                            className="custom-radio"
                          />
                        </div>
                        <label htmlFor={innerItem?.type}>
                          <div className="wrap">
                            <img
                              className="sslImage"
                              src={`https://img.rockstreamer.com/https://graphic.rockstreamer.com/${innerItem.operatorLogo}`}
                              alt={innerItem?.type}
                            />
                            {/* <div className="text">
                            <div>{innerItem?.operatorName}</div>
                            <span>{innerItem?.operatorAdditional}</span>
                          </div> */}
                          </div>
                        </label>
                        {innerItem?.type === "coupon" &&
                          selectedMethod?.type === "coupon" && (
                            <>
                              <PromoWrap couponStatus={couponStatus}>
                                {couponStatus === "true" ? (
                                  <span className="coupon-message success">
                                    {couponMessage ||
                                      "You have got discount on this package"}
                                  </span>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      name="promo"
                                      id="promo"
                                      value={promoCode}
                                      onChange={(e) =>
                                        setPromoCode(e.target.value)
                                      }
                                      placeholder="Enter promo code if any"
                                      autoComplete="off"
                                      disabled={couponLoading}
                                    />
                                    <button
                                      type="button"
                                      className="apply-btn"
                                      onClick={handlePromo}
                                      disabled={couponLoading || !promoCode}
                                    >
                                      {couponLoading ? "..." : "APPLY"}
                                    </button>
                                  </>
                                )}
                              </PromoWrap>
                              {couponStatus === "false" && (
                                <PromoMessage>
                                  {couponMessage || "Invalid coupon code"}
                                </PromoMessage>
                              )}
                            </>
                          )}
                      </ActivePayment>
                    );
                  })
                ) : (
                  <div className="no-payment-found">
                    No Payment Methods Found!
                  </div>
                )}
              </div>
            </SinglePackage>
            <SinglePackage className="only-payment-summary desktop">
              <div className="title">Payment Summary</div>
              <div className="divider"></div>
              <div className="all-summaries">
                <div className="total">
                  <div>Total</div>
                  <div>
                    {isCoupon ? 0 : selectedPackage?.price}{" "}
                    {selectedPackage?.unit}
                  </div>
                </div>
                <div className="total-payable">
                  <div>Total Payable</div>
                  <div>
                    {isCoupon ? 0 : selectedPackage?.price}{" "}
                    {selectedPackage?.unit}
                  </div>
                </div>
              </div>
              <div
                className={`pay-btn${isContinueDisabled ? " disabled" : ""}`}
                onClick={isContinueDisabled ? undefined : handleSubmit}
              >
                CONTINUE
              </div>
            </SinglePackage>
            <SinglePackage className="only-payment-summary mobile">
              <div className="transition-wrapper">
                <div className="bg-gradient"></div>
                <section className="contents">
                  <div className="title">Payment Summary</div>
                  <div className="divider"></div>
                  <div className="all-summaries">
                    <div className="total">
                      <div>Total</div>
                      <div>
                        {isCoupon ? 0 : selectedPackage?.price}{" "}
                        {selectedPackage?.unit}
                      </div>
                    </div>
                    <div className="total-payable">
                      <div>Total Payable</div>
                      <div>
                        {isCoupon ? 0 : selectedPackage?.price}{" "}
                        {selectedPackage?.unit}
                      </div>
                    </div>
                  </div>
                  <div className="pay-btn" onClick={handleSubmit}>
                    CONTINUE
                  </div>
                </section>
              </div>
            </SinglePackage>
          </PackagesContainer>
        )}
      </Wrapper>
    </Container>
  );
};

const Title = styled.h4`
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 600;

  @media (max-width: 575.99px) {
    font-size: 16px;
    margin-bottom: 0.1rem;
  }
`;

const Subtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 0;
  font-size: 14px;
  text-align: left;

  li:first-child {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 575.99px) {
    font-size: 12px;
  }
`;
const PromoWrap = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 100%;
  width: 100%;
  margin-top: 0.9rem;
  height: 3rem;
  border: 2px solid
    ${(props) => (props.couponStatus === "true" ? "green" : "var(--button-bg)")};
  border-radius: 8px;
  overflow: hidden;
  background: var(--white);

  input[type="text"] {
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 0 1rem;
    border: none;
    outline: none;
    font-size: 0.9rem;
    color: var(--black);
    background: var(--white);
  }
  input[type="text"]::placeholder {
    color: var(--silver);
  }

  .apply-btn {
    height: 100%;
    padding: 0 2rem;
    border: none;
    outline: none;
    background: var(--button-bg);
    color: var(--button-front);
    font-weight: 700;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: background 250ms ease-in-out;
  }
  .apply-btn:hover {
    background: var(--button-hover);
  }
  .apply-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .coupon-message {
    flex: 1;
    padding: 0 1rem;
    font-size: 0.85rem;
    font-weight: 500;
  }
  .coupon-message.success {
    color: green;
  }

  @media (max-width: 600px) {
    width: 100%;
    .apply-btn {
      padding: 0 1.4rem;
      font-size: 0.8rem;
    }
  }
`;

const PromoMessage = styled.p`
  flex-basis: 100%;
  width: 100%;
  margin-top: 0.4rem;
  text-align: left;
  font-size: 0.8rem;
  color: var(--button-bg);
`;

export default PaymentPage;
